import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { RoomTypesQuery } from '../gql/graphql';

const roomTypes = graphql(/* GraphQL */ `
  query roomTypes($boatId: Int!, $tripId: Int!) {
    roomTypes(boatId: $boatId, tripId: $tripId) {
      typeId
      typeName
      boatId
      numberOfRooms
      bedTypeName
      deckLevelName
      occupancy
      price
      totalAvailable
      roomFacilities {
        roomFacilityId
        typeId
        facilityId
        name
        facilityGroupId
        sort
        iconName
      }
      roomPhotos {
        imageId
        imageUrl
        isHero
        typeId
      }
    }
  }
`);

const useGetBoatRooms = (boatId: number, tripId: number) => {
  const { data, isLoading } = useQuery<RoomTypesQuery>({
    queryKey: ['boatRooms', boatId, tripId],
    queryFn: async () =>
      graphqlRequest<RoomTypesQuery>(roomTypes, {
        boatId,
        tripId,
      }), // Public endpoint, no auth needed
    staleTime: 3600000,
    retry: shouldRetryQuery,
  });

  return {
    boatRooms: data,
    boatRoomsLoading: isLoading,
  };
};

export default useGetBoatRooms;
